module.exports = __webpack_public_path__ + "fonts/ARIALNI.30e9defa.TTF";